'use client';

import { Toaster as Sonner } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group pointer-events-auto"
      closeButton
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton:
            '!bg-wb-orange !text-white !rounded !shadow-xs hover:!bg-wb-orange/70',
          cancelButton:
            'group-[.toast]:bg-input group-[.toast]:text-muted-foreground',
          closeButton: '!text-black',
          success: '!bg-wb-grass !text-white',
          error: '!bg-wb-sienna !text-white',
          warning: '!bg-wb-orange !text-black',
          info: '!bg-wb-blue !text-white',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
